<div class="info-container">
  <div class="flex">
    <div class="label header label-header ">{{'bikeshop.rentals.booking.payment_status' | translate}}</div>

    <div class="payment-status-label" [ngClass]="{
      'not-paid': reservation.paymentStatusID === 0,
      'paid': reservation.paymentStatusID === 10,
      'deposit-paid': reservation.paymentStatusID === 1,
      'partial-payment': reservation.paymentStatusID === 2,
      'partial-refund': reservation.paymentStatusID === 19,
      'fully-refunded': reservation.paymentStatusID === 20
    }">{{reservation.paymentStatus}}</div>

    <div class="qr-container" *ngIf="qrCodeURL">
      <qrcode pTooltip="{{ 'bikeshop.rentals.booking.qr_payment_tooltip' | translate }}" [width]="120"
        (click)="openPaymentLink()" [qrdata]="qrCodeURL" colordark="rgba(30, 30, 30, 1)" usesvg="true">
      </qrcode>
    </div>
  </div>

  <div class="payment-history-container" *ngIf="reservationPaymentHistory && reservationPaymentHistory.length > 0">
    <div class="header">
      <div class="sync-status">
        <span style="width: 21px"></span>
      </div>
      <div>{{ 'bikeshop.rentals.booking.payment_method' | translate }}</div>
      <div>{{ 'bikeshop.rentals.booking.payment_date' | translate }}</div>
      <div style="flex: 1.5">{{ 'bikeshop.rentals.booking.identifier' | translate }}</div>
      <div>{{ 'bikeshop.rentals.booking.payment_amount' | translate }}</div>
      <div style="flex: 1.2" *ngIf="hasRefund">{{ 'bikeshop.rentals.booking.refunds' | translate }}</div>
    </div>

    <div *ngFor="let payment of reservationPaymentHistory">
      <div class="sync-status">
        
        <span class="hubtiger-pos-sent" *ngIf="payment.paymentSentToPOS && canHandlePayments()"></span>
        <span class="hubtiger-pos-not-sent" *ngIf="!payment.paymentSentToPOS && canHandlePayments()"></span>
        <span style="width:21px" *ngIf="!canHandlePayments()"></span>
      </div>
      <div>{{payment.paymentMethod}}</div>
      <div>{{(payment.createdDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
      <div style="flex: 1.5">{{payment.paymentMethod !== 'POS' ? payment.stripePaymentIntent : '' }}</div>
      <div>{{partner.CurrencySymbol}}{{payment.amountPaid.toFixed(2)}}</div>
      <div style="flex: 1.2" *ngIf="hasRefund">
        <div *ngFor="let refund of payment.refunds" class="refund">
          <div>{{partner.CurrencySymbol}}{{refund.amountRefunded.toFixed(2)}}</div>
          <div>{{(refund.createdDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="sync-button-container row"
    *ngIf="canHandlePayments() && ((invoice && invoice.externalKey) || (invoice && canRefund))">
    <div class="col-md-2"></div>
    <div class="col-md-4">
      <button pButton type="button" *ngIf="(invoice && canRefund)" class="p-button-raised full-width accent"
        (click)="initiateRefund()" label="{{'bikeshop.rentals.booking.initiate_refund'| translate}}"></button>
    </div>
    <div class="col-md-4">
      <button pButton type="button" *ngIf="invoice && invoice.externalKey && canHandlePayments()"
        [disabled]="busySyncing" class="p-button-raised full-width" (click)="syncPayments()"
        label="{{'bikeshop.rentals.booking.sync_payments'| translate}}"></button>
    </div>
  </div>

  <div class="sync-button-container row" *ngIf="invoice && invoice.hasSplitPayments && hasPaymentsNotSyncd()">
    <div class="col-md-2"></div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <button pButton type="button" [disabled]="busySyncing" class="p-button-raised full-width"
        (click)="syncLongTermPayments()" label="{{'bikeshop.rentals.booking.sync_payments'| translate}}"></button>
    </div>
  </div>

  <div class="sync-button-container row" *ngIf="((invoice && invoice.paymentStatus !== 10) || canRefund) && !canHandlePayments()">
    <div class="col-md-2"></div>
    <div class="col-md-4">
      <button pButton type="button" *ngIf="(invoice && canRefund)" class="p-button-raised full-width accent"
        (click)="initiateRefund()" label="{{'bikeshop.rentals.booking.initiate_refund'| translate}}"></button>
    </div>
    <div class="col-md-4">
      <button pButton type="button" *ngIf="invoice && invoice.paymentStatus !== 10" [disabled]="markingAsPaid" class="p-button-raised full-width" (click)="markAsPaid()"
        label="{{'bikeshop.rentals.booking.mark_as_paid'| translate}}"></button>
    </div>
  </div>

</div>



<p-dialog header="{{ 'bikeshop.rentals.booking.initiate_refund' | translate }}" [(visible)]="showInitiateRefundDialog"
  [modal]="true" [responsive]="true" [style]="{width: '600px', 'padding': '32px'}"
  [contentStyle]="{'overflow':'visible', 'height': 'inherit'}" *ngIf="showInitiateRefundDialog">
  <app-initiate-rental-payment-refund [payments]="reservationPaymentHistory" [partner]="partner"
    [countryData]="countryData" (refundComplete)="refundComplete()"></app-initiate-rental-payment-refund>
</p-dialog>